import { changeRedirectUrl } from '@fh-components/fh-js-api-core/store/slices/userSlice';
import { isLoggedInSelector } from '@/store';
import Router from 'next/router';

export default function withAuth(f) {
	return async args => {
		const { res, reduxStore, pathname, asPath } = args;

		const loggedIn = isLoggedInSelector(reduxStore.getState());
		if (loggedIn) {
			return f(args);
		}
		if (res) {
			res.cookie('fh_redirect_url', pathname, {
				path: '/',
				expires: new Date(Date.now() + 3600 * 1000),
			});
			res.writeHead(302, {
				Location: '/login',
			});
			res.end();
		} else {
			await reduxStore.dispatch(changeRedirectUrl({ href: pathname, asPath }));
			Router.push('/login');
		}

		return {};
	};
}
